(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/match-number-icon/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tipsen/match-number-icon/assets/javascripts/constants.js');
"use strict";


const matchCorrectStatusColor = {
  CORRECT: 'green',
  NOT_CORRECT: 'red',
  POSSIBLE_WIN: 'yellow',
  NONE: 'purple',
  FULLTRAFF: 'fulltraff',
  ODDSET: 'oddset'
};
const matchNumberTextColor = {
  WHITE: 'white',
  BLACK: 'black'
};
const matchNumberIconSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
setGlobal('svs.components.tipsen.matchNumberIcon.constants', {
  matchNumberTextColor,
  matchNumberIconSize,
  matchCorrectStatusColor
});

 })(window);